(function () {
  'use strict';
  var root = document.querySelector('[data-product-section]');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Gallery: arrows, keyboard, swipe and a photo counter */
  var gallery = $('[data-gallery]', root);
  if (gallery) {
    var slides = $$('.gallery__slide', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    var counter = $('[data-gallery-count]', gallery);

    var currentIndex = function () {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    };
    var syncCounter = function () {
      if (counter) counter.textContent = (currentIndex() + 1) + ' / ' + slides.length;
    };
    var go = function (i) {
      if (slides.length < 2) return;
      i = (i + slides.length) % slides.length;
      var id = slides[i].getAttribute('data-media-id');
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === id;
        t.classList.toggle('is-active', on);
        if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    };

    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { go(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { go(currentIndex() + 1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(currentIndex() - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(currentIndex() + 1); e.preventDefault(); }
    });

    var startX = null;
    var main = $('.gallery__main', gallery);
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 45) go(currentIndex() + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(syncCounter).observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
    syncCounter();
  }

  /* Sticky add to cart: appears once the main button scrolls out of view */
  var bar = $('[data-sticky-atc]', root);
  var atc = $('[data-atc]', root);
  var form = $('[data-product-form]', root);
  if (bar && atc && form && 'IntersectionObserver' in window) {
    var visible = true;
    var toggle = function () {
      var show = !visible && window.scrollY > 200;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = $('[data-sticky-submit]', bar);
      if (b) b.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      toggle();
    }).observe(atc);
    window.addEventListener('scroll', toggle, { passive: true });

    var stickyBtn = $('[data-sticky-submit]', bar);
    var stickyPrice = $('[data-sticky-price]', bar);
    stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    var syncBar = function () {
      var price = $('[data-price] .price', root);
      if (price && stickyPrice) stickyPrice.textContent = price.textContent.replace(/\s*USD\s*$/i, '').trim();
      stickyBtn.disabled = atc.disabled;
      stickyBtn.textContent = atc.disabled ? atc.textContent.trim() : 'Add to cart';
    };
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncBar);
      mo.observe(atc, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      var priceBox = $('[data-price]', root);
      if (priceBox) mo.observe(priceBox, { childList: true, subtree: true });
    }
  }
})();
